import(/* webpackMode: "eager", webpackExports: ["ContactForm"] */ "/builds/tradingvalley-frontend/growin/apps/web/features/contact-us/components/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/contact/robo-qr-code.png");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/apps/web/public/contact/stockmining-qr-code.png");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/builds/tradingvalley-frontend/growin/node_modules/next/dist/client/link.js");
